import { OperationMS } from '../../types';
import { CommandeAnalyse } from '../analyse/types';

// Recap read-only « Preparation du Marche Subsequent » : derive UNIQUEMENT de `operation`
// + la commande retenue (aucun fetch dedie ; les champs sont deja dans le payload de l'operation).

export interface RecapField {
  label: string;
  value: string;
}

const PLACEHOLDER = '—';

// Accord-cadre en vigueur : edition courante, derivee de l'annee d'edition (env), comme les
// libelles figes ailleurs dans l'app (ex. ReadOnlyDocuments). L'edition couvre annee N a N+1.
const ANNEE = process.env.REACT_APP_ANNEE_EDITION || '25';
const ANNEE_DEBUT = `20${ANNEE}`;
const ANNEE_FIN = `20${Number(ANNEE) + 1}`;
export const ACCORD_CADRE_EDITION = `Accord-cadre édition ${ANNEE_DEBUT}-${ANNEE_FIN}`;
export const ACCORD_CADRE_VALIDITE = `01/01/${ANNEE_DEBUT} au 31/12/${ANNEE_FIN}`;

const lotLabel = (id?: number | string, nom?: string): string => {
  const parts = [id, nom].filter((p) => p !== undefined && p !== null && String(p).length > 0);
  return parts.length ? parts.join(' - ') : PLACEHOLDER;
};

const dateOnly = (iso?: string): string => {
  if (!iso) return PLACEHOLDER;
  const d = new Date(iso);
  return Number.isNaN(d.getTime())
    ? PLACEHOLDER
    : d.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

export const buildPreparationRecap = (
  operation: OperationMS,
  retenu?: CommandeAnalyse,
): RecapField[] => {
  const entite = retenu?.contrat?.entite;
  const dep = operation.lot_departement?.departement;
  return [
    { label: 'Accord-cadre en vigueur', value: ACCORD_CADRE_EDITION },
    { label: 'Date de validité', value: ACCORD_CADRE_VALIDITE },
    { label: 'Lot technique', value: lotLabel(operation.lot_technique?.id, operation.lot_technique?.nom) },
    { label: 'Lot géographique', value: lotLabel(dep?.id, dep?.nom) },
    { label: 'N° contrat du titulaire', value: retenu?.contrat?.numero || PLACEHOLDER },
    { label: 'Nom du titulaire', value: entite?.nom || PLACEHOLDER },
    { label: 'SIRET', value: entite?.siret || PLACEHOLDER },
    { label: "Date prévisionnelle de fin d'opération", value: dateOnly(operation.date_fin_operation) },
    { label: "Nom de l'opération", value: operation.nom || PLACEHOLDER },
    { label: 'N° du Marché Subséquent', value: String(operation.numero ?? PLACEHOLDER) },
  ];
};
